import { c as _c } from "react/compiler-runtime";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useB3Config } from "../../../../global-account/react/index.js";
import { Tabs, TabsContent, TabsList, TabTrigger } from "../ui/Tabs.js";
import { Header } from "./Header.js";
import HomeActions from "./HomeActions.js";
import NFTContent from "./NFTContent.js";
import ProfileSection from "./ProfileSection.js";
import TokenContent from "./TokenContent.js";
export function HomeContent(t0) {
  const $ = _c(4);
  const {
    showDeposit: t1,
    showSwap: t2
  } = t0;
  const showDeposit = t1 === undefined ? false : t1;
  const showSwap = t2 === undefined ? true : t2;
  const {
    authStrategy
  } = useB3Config();
  const isBetterAuth = authStrategy === "better-auth";
  let t3;
  if ($[0] !== isBetterAuth || $[1] !== showDeposit || $[2] !== showSwap) {
    t3 = _jsxs("div", {
      className: "flex flex-col",
      children: [_jsx(Header, {}), _jsxs("div", {
        className: "flex flex-col",
        children: [_jsx(ProfileSection, {}), !isBetterAuth && _jsx(HomeActions, {
          showDeposit,
          showSwap
        }), !isBetterAuth && _jsx("div", {
          className: "b3-modal-balance-content space-y-2 p-5",
          children: _jsxs(Tabs, {
            defaultValue: "balance",
            children: [_jsxs(TabsList, {
              className: "b3-modal-balance-tabs-list",
              children: [_jsx(TabTrigger, {
                value: "balance",
                className: "font-neue-montreal-semibold p-0 pr-3",
                children: "Balance"
              }), _jsx(TabTrigger, {
                value: "nfts",
                className: "font-neue-montreal-semibold p-0 pr-3",
                children: "NFTs"
              })]
            }), _jsx(TabsContent, {
              value: "balance",
              className: "px-0 pb-4 pt-2",
              children: _jsx(TokenContent, {})
            }), _jsx(TabsContent, {
              value: "nfts",
              className: "px-0 pb-4 pt-2",
              children: _jsx(NFTContent, {})
            })]
          })
        })]
      })]
    });
    $[0] = isBetterAuth;
    $[1] = showDeposit;
    $[2] = showSwap;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}